import jsonwebtoken from 'jsonwebtoken';
import { observable, action } from 'mobx';

// jwt refreshing setInterval variable
let jwtRefreshing = null;

// const for the local storage key name
const jwtStorageKey = 'jwt';
const jwtDataStorageKey = 'jwtData';

// observable for the status of the jwt refreshing
export const tokenData = observable({
  jwt: '',
  jwtData: {},
  connectErrCount: 0,
});

export function SetTokenData(jwt, jwtData) {
  // do further check for jwt format or length?
  localStorage.setItem(jwtStorageKey, jwt);
  localStorage.setItem(jwtDataStorageKey, JSON.stringify(jwtData));
  action(() => {
    tokenData.connectErrCount = 0;
    tokenData.jwt = jwt;
    tokenData.jwtData = jwtData;
  })();
}

// method to remove jwt from local storage
export const RemoveJwt = () => {
  // remove the jwt
  action(() => {
    tokenData.jwt = '';
    tokenData.jwtData = {};
  })();
  localStorage.removeItem(jwtStorageKey);
  localStorage.removeItem(jwtDataStorageKey);
};

export function SetToken(jwt) {
  try {
    const decoded = jsonwebtoken.decode(jwt);
    if (decoded) {
      SetTokenData(jwt, decoded);
    } else {
      RemoveJwt();
    }
  } catch (err) {
    RemoveJwt();
    console.error(`${err.name}: ${err.message}`);
  }
}

const IncrConnErr = () => {
  action(() => {
    tokenData.connectErrCount += 1;
  })();
};

// function to calculate the delay time;
const reconnectDelayTime = () => {
  const delayTime = tokenData.connectErrCount * 500;

  // maximum delay time is 3 seconds
  return delayTime < 3000 ? delayTime : 3000;
};

// function to get the most up-to-date jwt
export const getJwt = () => {
  // if jwt is expired we should removeJwt and re-request it
  return tokenData.jwt;
};

// function to get the most up-to-date jwtData
const getJwtData = () => {
  // if jwt is expired we should removeJwt and re-request it
  return tokenData.jwtData;
};

export const refresher = {
  clientStore: null,
  refreshToken: async () => {
    // delay refresh token based on the error count
    await new Promise(resolve => {
      setTimeout(resolve, reconnectDelayTime());
    });

    const response = await fetch(`${MAIN_URL}/auth/token`, {
      credentials: 'include',
    });

    // user is not logged in, can not get the token
    if (response.status === 401) {
      if (refresher.clientStore) {
        refresher.clientStore.SignOutUser();
      }
      return null;
    }

    const jwt = await response.text();
    try {
      const decoded = jsonwebtoken.decode(jwt);
      if (decoded) {
        SetTokenData(jwt, decoded);
      } else {
        RemoveJwt();
      }
    } catch (err) {
      IncrConnErr();
      RemoveJwt();
      console.error(`${err.name}: ${err.message}`);
    }
    return jwt;
  },
};

function SetTokenDataFromLocal() {
  const jwtData = localStorage.getItem(jwtDataStorageKey);
  const jwtDataObj = jwtData ? JSON.parse(jwtData) : {};
  const jwt = localStorage.getItem(jwtStorageKey);
  if (jwt !== null) {
    // the localStorage key exists
    SetTokenData(jwt, jwtDataObj);
  }
  if (jwt === 'null') {
    RemoveJwt();
  }
}

// Check if the jwt is going to expire in the next 4 minutes.
// if it is going to expire refresh the token.
export const startJwtRefreshing = async () => {
  SetTokenDataFromLocal();
  // check if the jwt is set
  const jwt = getJwt();
  if (!jwt) {
    // call refresh token
    await refresher.refreshToken();
  }
  // check if the interval is running
  if (!jwtRefreshing) {
    jwtRefreshing = setInterval(async () => {
      const decoded = getJwtData();
      const now = new Date().getTime() / 1000;
      const exp = decoded?.exp || -1;
      if (now + 4 * 60 > exp) {
        await refresher.refreshToken();
      }
    }, 4 * 60 * 1000);
  }
};

// function to stop the jwt refreshing interval
export const stopJwtRefreshing = () => {
  if (jwtRefreshing) {
    clearInterval(jwtRefreshing);
    jwtRefreshing = null;
  }
};
